var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 16.6667H5.16683C4.23341 16.6667 3.76635 16.6667 3.40983 16.4851C3.09623 16.3253 2.84144 16.0704 2.68166 15.7568C2.5 15.4003 2.5 14.9335 2.5 14.0001V4.16675M17.5 5.83341L12.6286 10.0959C12.0452 10.6064 11.7534 10.8616 11.4339 10.9676C11.0571 11.0926 10.6479 11.079 10.2803 10.9292C9.96857 10.8022 9.69463 10.5282 9.14647 9.97999C8.61021 9.44373 8.34208 9.1756 8.0363 9.04875C7.67559 8.89911 7.27396 8.88081 6.90119 8.99717C6.58517 9.09582 6.29377 9.33859 5.71116 9.8241L2.5 12.5001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/Forecast.e9b3e0d939459ce812e14c9ba3076c48.svg";
export { ForwardRef as ReactComponent };